export default `:host(ids-draggable) {
  height: fit-content;
  width: fit-content;
}

:host(ids-draggable:not([handle])) {
  cursor: var(--ids-cursor-move);
  touch-action: none;
}

:host(ids-draggable[disabled]:not([handle])) {
  cursor: inherit;
}

:host(ids-draggable[axis=x]:not([disabled])) {
  cursor: var(--ids-cursor-resize-x);
}

:host(ids-draggable[axis=y]:not([disabled])) {
  cursor: var(--ids-cursor-resize-y);
}

ids-draggable[is-dragging]:not([handle]) {
  cursor: var(--ids-cursor-grabbing);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtZHJhZ2dhYmxlIiwic291cmNlcyI6WyJpZHMtZHJhZ2dhYmxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdChpZHMtZHJhZ2dhYmxlKSB7XG4gIGhlaWdodDogZml0LWNvbnRlbnQ7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbn1cblxuOmhvc3QoaWRzLWRyYWdnYWJsZTpub3QoW2hhbmRsZV0pKSB7XG4gIGN1cnNvcjogdmFyKC0taWRzLWN1cnNvci1tb3ZlKTtcbiAgdG91Y2gtYWN0aW9uOiBub25lO1xufVxuXG46aG9zdChpZHMtZHJhZ2dhYmxlW2Rpc2FibGVkXTpub3QoW2hhbmRsZV0pKSB7XG4gIGN1cnNvcjogaW5oZXJpdDtcbn1cblxuOmhvc3QoaWRzLWRyYWdnYWJsZVtheGlzPSd4J106bm90KFtkaXNhYmxlZF0pKSB7XG4gIGN1cnNvcjogdmFyKC0taWRzLWN1cnNvci1yZXNpemUteCk7XG59XG5cbjpob3N0KGlkcy1kcmFnZ2FibGVbYXhpcz0neSddOm5vdChbZGlzYWJsZWRdKSkge1xuICBjdXJzb3I6IHZhcigtLWlkcy1jdXJzb3ItcmVzaXplLXkpO1xufVxuXG5pZHMtZHJhZ2dhYmxlW2lzLWRyYWdnaW5nXTpub3QoW2hhbmRsZV0pIHtcbiAgY3Vyc29yOiB2YXIoLS1pZHMtY3Vyc29yLWdyYWJiaW5nKTtcbn1cbiJdfQ== */`;
